import { Button, Select, Tooltip } from 'antd';
import RowLoader from 'components/Sceletons/RowLoader';
import { tariffsData, Tariffs, TariffData, profileTariffs } from '../tariffsData';
import classes from '../TariffsComponent.module.scss';
import { CaretRightFilled } from '@ant-design/icons';
import { CloseOutlined } from '@ant-design/icons';
import { CheckOutlined } from '@ant-design/icons';
import colors from '../../../scss/variables/colors.module.scss';

type RenderCellProps = {
  value: any;
  info: any;
  col: any;
  t: any;
  userData: any;
  isLoadingUserData: boolean;
  endedTariffLifetime: string | null;
  forAYear: boolean;
  handleOpenModal: (tariffName: Tariffs, quotaMode?: string) => void;
  updateDataSource?: (newDataSource: any) => void;
  dataSource?: any[];
  mode: 'single' | 'quota';
  tariffsApiData: TariffData[];
  isTariffsLoading: boolean;
  roomConstraints: {
    members_amount: number;
    total_document_size: number;
  } | null;
};
const iconCheck = (
  <CheckOutlined className={classes.iconWithPadding} style={{ color: colors.excel }} />
);
const iconClose = (
  <CloseOutlined className={classes.iconWithPadding} style={{ color: colors.red }} />
);
const iconCheckGray = (
  <CheckOutlined className={classes.checkGrey} />
);
const pointIcon = (
  <CaretRightFilled className={classes.caretIcon} />
);

const publicFunctions = [
  'water_marks',
  'document_encryption',
  'documents_approval',
  'chats',
  'versions',
  'contact_list',
  'base_func',
  'doc_link',
  'timeline',
  'doc_chat',
  'privace_report',
  'privace_terms',
  'privace_nda',
];

const requestFunc = [
  'electronic_signature',
  'SSO',
  'integrations_website',
  'integrations_payment',
  'integrations_schedulers',
];

const rowOn4Columns = [
  'compare_title',
  'safety_subTitle',
  'documents_subTitle',
  'confident_subTitle',
  'integrations_subTitle',
  'additional_subTitle',
];

const contactUsAdress =
  window.REACT_APP_CONTACT_US !== 'REPLACE_REACT_APP_CONTACT_US'
    ? window.REACT_APP_CONTACT_US
    : process.env.REACT_APP_CONTACT_US || 'https://demo.tazadeal.com/contact';

export const renderCell = ({
  value,
  info,
  col,
  t,
  userData,
  isLoadingUserData,
  endedTariffLifetime,
  forAYear,
  handleOpenModal,
  updateDataSource,
  dataSource,
  mode,
  tariffsApiData,
  isTariffsLoading,
  roomConstraints,
}: RenderCellProps) => {

  const getCurrentTariff = (tariffName: string, quotaMode: string) => {
    let tariff;
    
    if (profileTariffs.includes(tariffName)) {
      tariff = tariffsApiData.find(t => t.name === Tariffs.Profile && t.type === tariffName);
    }
    else if (mode === 'quota' && quotaMode) {
      tariff = tariffsApiData.find(t => t.name === tariffName && t.type === quotaMode);
    }
    else {
      tariff = tariffsApiData.find(t => t.name === tariffName && !t.type);
    }

    return tariff;
  };

  if (info.key === 'tariff_name') {
    return (
      <div className={classes.tariff_name}>
        {t(`Tariffs.${info.key}.${col.key}`)}
      </div>
    );
  }

  if (info.key === 'price') {
    if (isTariffsLoading) {
      return (
        <div className={classes.price}>
          <RowLoader height={24} width={100} padding={'0 0 0 0'} />
        </div>
      );
    }

    if (col.key === Tariffs.Enterprise) {
      return (
        <div className={classes.price}>
          <span style={{ fontSize: 18, fontWeight: 500 }}>
            {t('Tariffs.custom_price')}
          </span>
        </div>
      );
    }

    const quotaModeIndex = dataSource?.findIndex((el: any) => el.key === 'quota_mode');
    const currentMode = quotaModeIndex !== undefined && quotaModeIndex >= 0 && dataSource ? 
      dataSource[quotaModeIndex]?.current_mode?.[col.key] : 'members';

    const tariff = getCurrentTariff(col.key, currentMode);
    if(!tariff) return null;

    if (col.key === Tariffs.Trial && tariff.name === Tariffs.Trial) {
      return (
        <div className={classes.price}>
          <span style={{ fontSize: 18, fontWeight: 500 }}>
            {t('Tariffs.14_days')}
          </span>
        </div>
      );
    }

    return (
      <div className={classes.price}>
        <span style={{ fontSize: 22, fontWeight: 500 }}>
          {tariff.base_cost}{' '}
        </span>
        <span style={{ fontSize: 22, fontWeight: 500 }}>
          {tariff.currency}
        </span>
        {t(`Tariffs.price`)}
      </div>
    );
  }

  if (info.key === 'number_of_users') {
    if (isTariffsLoading) {
      return (
        <div className={classes.users} style={{ fontWeight: 500 }}>
          <RowLoader height={20} width={120} padding={'0 0 0 0'} />
        </div>
      );
    }

    if (col.key === Tariffs.Enterprise) {
      return (
        <div className={classes.users} style={{ fontWeight: 500 }}>
          {t('Tariffs.participants_unlimited')}
        </div>
      );
    }

    const quotaModeIndex = dataSource?.findIndex((el: any) => el.key === 'quota_mode');
    const currentMode = quotaModeIndex !== undefined && quotaModeIndex >= 0 && dataSource ? 
      dataSource[quotaModeIndex]?.current_mode?.[col.key] : 'members';
    
    const tariff = getCurrentTariff(col.key, currentMode);
    if(!tariff) return null;
    
    const members = tariff.base_constraints.members;
    return (
      <div className={classes.users} style={{ fontWeight: 500 }}>
        {typeof members !== 'number' ? 
          t(`Tariffs.${info.key}_unlimited`) : 
          t(`Tariffs.${info.key}_count`, { count: members })
        }
      </div>
    );
  }

  if (info.key === 'by_it' || info.key === 'by_it_2') {
    const quotaModeIndex = dataSource?.findIndex((el: any) => el.key === 'quota_mode');
    const currentMode = quotaModeIndex !== undefined && quotaModeIndex >= 0 && dataSource ? 
      dataSource[quotaModeIndex]?.current_mode?.[col.key] : undefined;
    
    switch (col.key) {
      case Tariffs.Trial:
        return (
          <Tooltip title={t('Tariffs.onceAYear')}>
            <Button
              disabled={
                isTariffsLoading ||
                !userData?.can_take_trial ||
                isLoadingUserData ||
                Boolean(endedTariffLifetime)
              }
              loading={isLoadingUserData || isTariffsLoading}
              style={{ width: '100%' }}
              type='primary'
              onClick={() => handleOpenModal(Tariffs.Trial)}
            >
              {t(`Tariffs.try_free`)}
            </Button>
          </Tooltip>
        );
      case Tariffs.Enterprise:
        return (
          <Button
            style={{ width: '100%' }}
            type='primary'
            onClick={() => (window.location.href = contactUsAdress)}
          >
            {t(`Tariffs.contact_us`)}
          </Button>
        );
      default:
        let isBlockedByConstraints = false;
        let blockReasons: string[] = [];
        
        if (roomConstraints && endedTariffLifetime) {
          const tariff = getCurrentTariff(col.key, currentMode || 'members');
          
          if (tariff) {
            const maxMembers = tariff.base_constraints.members;
            const maxStorage = tariff.base_constraints.storage;
            
            if (typeof maxMembers === 'number' && roomConstraints.members_amount > maxMembers) {
              isBlockedByConstraints = true;
              blockReasons.push(
                t('Tariffs.block_reason.members', {
                  current: roomConstraints.members_amount,
                  max: maxMembers
                })
              );
            }
            
            if (typeof maxStorage === 'number' && roomConstraints.total_document_size > maxStorage) {
              isBlockedByConstraints = true;
              blockReasons.push(
                t('Tariffs.block_reason.storage', {
                  current: roomConstraints.total_document_size.toFixed(2),
                  max: maxStorage
                })
              );
            }
          }
        }
        
        const button = (
          <Button
            style={{ width: '100%' }}
            type='primary'
            disabled={isTariffsLoading || isLoadingUserData || isBlockedByConstraints}
            loading={isLoadingUserData || isTariffsLoading}
            onClick={() => handleOpenModal(col.key, currentMode)}
          >
            {`${t(`Tariffs.buy`)} ${t(`Tariffs.tariff_name.${col.key}`)}`}
          </Button>
        );
        
        if (isBlockedByConstraints && blockReasons.length > 0) {
          return (
            <Tooltip title={blockReasons.join('. ')}>
              {button}
            </Tooltip>
          );
        }
        
        return button;
    }
  }

  if (info.key === 'storage_capacity') {
    if (isTariffsLoading) {
      return (
        <div className={classes.storage_capacity}>
          {t(`Tariffs.${info.key}`)}
          <div
            style={{
              fontSize: 18,
              fontWeight: 500,
              paddingLeft: 6,
              textAlign: 'center',
            }}
          >
            <RowLoader height={20} width={80} padding={'0 0 0 0'} />
          </div>
        </div>
      );
    }

    if (col.key === Tariffs.Enterprise) {
      return (
        <div className={classes.storage_capacity}>
          {t(`Tariffs.${info.key}`)}
          <div
            style={{
              fontSize: 18,
              fontWeight: 500,
              paddingLeft: 6,
              textAlign: 'center',
            }}
          >
            {t('Tariffs.on_request')}
          </div>
        </div>
      );
    }

    const quotaModeIndex = dataSource?.findIndex((el: any) => el.key === 'quota_mode');
    const currentMode = quotaModeIndex !== undefined && quotaModeIndex >= 0 && dataSource ? 
      dataSource[quotaModeIndex]?.current_mode?.[col.key] : 'members';
    
    const tariff = getCurrentTariff(col.key, currentMode);
    if(!tariff) return null;
    
    const storage = tariff.base_constraints.storage;
    return (
      <div className={classes.storage_capacity}>
        {t(`Tariffs.${info.key}`)}
        <div
          style={{
            fontSize: 18,
            fontWeight: 500,
            paddingLeft: 6,
            textAlign: 'center',
          }}
        >
          {storage >= 1 ? `${storage} ${t('Tariffs.gb')}` : `${storage * 1000} ${t('Tariffs.mb')}`}
        </div>
      </div>
    );
  }

  if (info.key === 'quota_mode') {
    if (mode === 'quota' && updateDataSource && dataSource) {
      if (col.key === Tariffs.Enterprise) {
        return null;
      }

      if (isTariffsLoading) {
        return (
          <div style={{ padding: '8px 0' }}>
            <RowLoader height={24} width={120} padding={'0 0 0 0'} />
          </div>
        );
      }

      const availableTypes = tariffsApiData
        .filter(t => t.name === col.key)
        .map(t => t.type);
      
      const options = [];
      if (availableTypes.includes('members')) {
        options.push({ label: t('Tariffs.more_employees'), value: 'members' });
      }
      if (availableTypes.includes('rooms')) {
        options.push({ label: t('Tariffs.more_rooms'), value: 'rooms' });
      }

   
      return (
        <div style={{ padding: '8px 0' }}>
          <Select
            value={info.current_mode[col.key]}
            onChange={(value) => {
              const newDataSource = [...dataSource];
              const rightIndex = tariffsData.findIndex(
                (el) => el.key === 'quota_mode'
              );
              newDataSource[rightIndex].current_mode[col.key] = value;
              updateDataSource(newDataSource);
            }}
            options={options}
            style={{ width: '100%' }}
            size="middle"
          />
        </div>
      );
    }
    return null;
  }

  if (info.key === 'suitable_for') {
    return (
      <div className={classes.suitable_for}>
        <p style={{ fontWeight: 500 }}>
          {t(`Tariffs.${info.key}.${col.key}.${info.key}`)}
        </p>
        <div>{t(`Tariffs.${info.key}.${col.key}.1`)}</div>
        <div>{t(`Tariffs.${info.key}.${col.key}.2`)}</div>
        <div>{t(`Tariffs.${info.key}.${col.key}.3`)}</div>
        <div>{t(`Tariffs.${info.key}.${col.key}.4`)}</div>
        <div>{t(`Tariffs.${info.key}.${col.key}.5`)}</div>
      </div>
    );
  }

  if (info.key === 'you_get') {
    return <div style={{ fontWeight: 600 }}>{t('Tariffs.you_get')}</div>;
  }

  if (info.key === 'you_get_list') {
    if (isTariffsLoading) {
      return (
        <div className={classes.you_get_list}>
            <div>
              {pointIcon}
              <RowLoader height={16} width={150} padding={'0 0 0 0'} display="inline-block" verticalAlign="middle" />
            </div>
            <div>
              {pointIcon}
              <RowLoader height={16} width={120} padding={'0 0 0 0'} display="inline-block" verticalAlign="middle" />
            </div>
            <div>
              {pointIcon}
              <RowLoader height={16} width={140} padding={'0 0 0 0'} display="inline-block" verticalAlign="middle" />
            </div>
        </div>
      );
    }

    const quotaModeIndex = dataSource?.findIndex((el: any) => el.key === 'quota_mode');
    const currentMode = quotaModeIndex !== undefined && quotaModeIndex >= 0 && dataSource ? 
      dataSource[quotaModeIndex]?.current_mode?.[col.key] : 'members';
    
    const tariff = getCurrentTariff(col.key, currentMode);
    
    if (!tariff) {
      return (
        <div className={classes.you_get_list}>
          <div>
            {pointIcon}
            {t('Tariffs.unlimited_rooms')}
          </div>
          <div>
            {pointIcon}
            {t(`Tariffs.invite_participants`)}
          </div>
          <div>
            {pointIcon}
            {t(`Tariffs.mobile_application`)}
          </div>
        </div>
      );
    }

    const { members, storage, rooms } = tariff.base_constraints;

    return (
      <div className={classes.you_get_list}>
        {/* Рабочие пространства */}
        <div>
          {pointIcon}
          {typeof rooms !== 'number' || rooms === 1 ? 
            t('Tariffs.workspace_single') :
            t('Tariffs.workspace_count', { count: rooms })
          }
        </div>
        
        {/* Облачное хранилище */}
        <div>
          {pointIcon}
          {storage >= 1 ? 
            t('Tariffs.cloud_storage_gb', { size: storage }) : 
            t('Tariffs.cloud_storage_mb', { size: storage * 1000 })
          }
        </div>
        
        {/* Участники */}
        <div>
          {pointIcon}
          {typeof members !== 'number' ? 
            t('Tariffs.participants_unlimited') : 
            t('Tariffs.participants_count', { count: members })
          }
        </div>
        
        {/* Мобильное приложение */}
        <div>
          {pointIcon}
          {t(`Tariffs.mobile_application`)}
        </div>
        
        {/* Дополнительные возможности для платных тарифов */}
        {col.key !== Tariffs.Trial && (
          <div>
            {pointIcon}
            {t(`Tariffs.free_save_month`)}
          </div>
        )}
      </div>
    );
  }

  if (info.key === 'compare_title') {
    if ((mode === 'single' && col.key === Tariffs.Trial) || (mode === 'quota' && col.key === Tariffs.Basic)) {
      return (
        <div className={classes.compareTitle}>{t(`Tariffs.compare_title`)}</div>
      );
    }
  }

  if (info.key === 'room_num') {
    if (isTariffsLoading) {
      return (
          <div>
            {pointIcon}
            <RowLoader height={16} width={150} padding={'0 0 0 0'} display="inline-block" verticalAlign="middle" />
          </div>
      );
    }

    if (col.key === Tariffs.Enterprise) {
      return (
        <div>
          {pointIcon}
          {t('Tariffs.unlimited_rooms')}
        </div>
      );
    }

    const quotaModeIndex = dataSource?.findIndex((el: any) => el.key === 'quota_mode');
    const currentMode = quotaModeIndex !== undefined && quotaModeIndex >= 0 && dataSource ? 
      dataSource[quotaModeIndex]?.current_mode?.[col.key] : 'members';
    
    const tariff = getCurrentTariff(col.key, currentMode);
    if (!tariff) {
      return (
        <div>
          {pointIcon}
          {t(`Tariffs.room_num`)}
        </div>
      );
    }

    const rooms = tariff.base_constraints.rooms;
    return (
      <div>
        {pointIcon}
        {typeof rooms !== 'number' ? 
          t('Tariffs.workspace_unlimited') : 
          rooms === 1 ? 
            t('Tariffs.workspace_single') :
            t('Tariffs.workspace_count', { count: rooms })
        }
      </div>
    );
  }

  if (info.key === 'room_members') {
    if (isTariffsLoading) {
      return (
          <div>
            {pointIcon}
            <RowLoader height={16} width={150} padding={'0 0 0 0'} display="inline-block" verticalAlign="middle" />
          </div>
      );
    }

    if (col.key === Tariffs.Enterprise) {
      return (
        <div>
          {pointIcon}
          {t('Tariffs.invite_participants')}
        </div>
      );
    }

    const quotaModeIndex = dataSource?.findIndex((el: any) => el.key === 'quota_mode');
    const currentMode = quotaModeIndex !== undefined && quotaModeIndex >= 0 && dataSource ? 
      dataSource[quotaModeIndex]?.current_mode?.[col.key] : 'members';
    
    const tariff = getCurrentTariff(col.key, currentMode);
    if (!tariff) {
      return (
        <div>
          {pointIcon}
          {t(`Tariffs.room_members`)}
        </div>
      );
    }

    const members = tariff.base_constraints.members;
    return (
      <div>
        {pointIcon}
        {typeof members !== 'number' ? 
          t('Tariffs.room_members_unlimited') : 
          t('Tariffs.room_members_count', { count: members })
        } 
      </div>
    );
  }

  if (info.key === 'cloud_storage') {
    if (isTariffsLoading) {
      return (
          <div>
            {pointIcon}
            <RowLoader height={16} width={150} padding={'0 0 0 0'} display="inline-block" verticalAlign="middle" />
          </div>
      );
    }

    const quotaModeIndex = dataSource?.findIndex((el: any) => el.key === 'quota_mode');
    const currentMode = quotaModeIndex !== undefined && quotaModeIndex >= 0 && dataSource ? 
      dataSource[quotaModeIndex]?.current_mode?.[col.key] : 'members';
    
    const tariff = getCurrentTariff(col.key, currentMode);
    if (!tariff) {
      return <div>{'-'}</div>;
    }

    const storage = tariff.base_constraints.storage;
    return (
      <div>
        {pointIcon}
        {storage >= 1 ? 
          t('Tariffs.cloud_storage_gb', { size: storage }) : 
          t('Tariffs.cloud_storage_mb', { size: storage * 1000 })
        }
      </div>
    );
  }

  if (info.key === 'additional_storage') {
    switch (col.key) {
      case Tariffs.Trial:
        return (
          <div>
            {iconClose}
            {t(`Tariffs.${info.key}`)}
          </div>
        );
       case Tariffs.Storage:
         return (
           <div>
             <div>
               {iconCheck}
               {t(`Tariffs.${info.key}`)}
             </div>
             <div style={{ fontSize: 12 }}>
               {t(`Tariffs.*additional_storage`)}
             </div>
           </div>
         );
       case Tariffs.Basic:
         return (
           <div>
             <div>
               {iconCheck}
               {t(`Tariffs.${info.key}`)}
             </div>
             <div style={{ fontSize: 12 }}>
               {t(`Tariffs.*additional_storage`)}
             </div>
           </div>
         );
       case Tariffs.Start:
         return (
           <div>
             <div>
               {iconCheck}
               {t(`Tariffs.${info.key}`)}
             </div>
             <div style={{ fontSize: 12 }}>
               {t(`Tariffs.*additional_storage`)}
             </div>
           </div>
         );
       case Tariffs.Advanced:
         return (
           <div>
             <div>
               {iconCheck}
               {t(`Tariffs.${info.key}`)}
             </div>
             <div style={{ fontSize: 12 }}>
               {t(`Tariffs.*additional_storage`)}
             </div>
           </div>
         );
      case Tariffs.Simple:
        return (
          <div>
            <div>
              {iconCheck}
              {t(`Tariffs.${info.key}`)}
            </div>
            <div style={{ fontSize: 12 }}>
              {t(`Tariffs.*additional_storage`)}
            </div>
          </div>
        );
      case Tariffs.Members:
        return (
          <div>
            <div>
              {iconCheck}
              {t(`Tariffs.${info.key}`)}
            </div>
            <div style={{ fontSize: 12 }}>
              {t(`Tariffs.*additional_storage`)}
            </div>
          </div>
        );
      default:
        return <div>{'-'}</div>;
    }
  }

  if (info.key === 'preconfigured_roles') {
    return (
      <div>
        {iconCheck}
        {t(`Tariffs.preconfigured_roles`)}
      </div>
    );
  }

  if (info.key === 'back_up') {
    switch (col.key) {
      case Tariffs.Trial:
        return (
          <div>
            {iconClose}
            {t(`Tariffs.back_up`)}
          </div>
        );
      default:
        return (
          <div>
            {iconCheck}
            {t(`Tariffs.back_up`)}
          </div>
        );
    }
  }

  if (rowOn4Columns.includes(info.key)) {
    if ((mode === 'single' && col.key === Tariffs.Trial) || (mode === 'quota' && col.key === Tariffs.Basic)) {
      return <div className={classes.subTitle}>{t(`Tariffs.${info.key}`)}</div>;
    }
  }

  if (info.key === '2FA') {
    return (
      <div>
        {iconCheck}
        {t(`Tariffs.${info.key}`)}
      </div>
    );
  }

  if (requestFunc.includes(info.key)) {
    return col.key === Tariffs.Trial ? (
      <div>
        {iconClose}
        {t(`Tariffs.${info.key}`)}
      </div>
    ) : (
      <div>
        <div>
          {iconCheckGray}
          {t(`Tariffs.${info.key}`)}*
        </div>
        <div>{t(`Tariffs.*SSO`)}</div>
      </div>
    );
  }

  if (info.key === 'user_activity_log') {
    return (
      <div>
        {iconCheck}
        {t(`Tariffs.user_activity_log`)}
      </div>
    );
  }

  if (publicFunctions.includes(info.key)) {
    return (
      <div>
        {iconCheck}
        {t(`Tariffs.${info.key}`)}
      </div>
    );
  }

  return null;
};
